export default function PHP_get_host_info() {
  return (
    <div>
      <h1>PHP_get_host_info</h1>
    </div>
  );
}
